import { yupResolver } from '@hookform/resolvers/yup'
import { Box, Grid, Button, MobileStepper } from '@mui/material'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'

import { Alert } from '../../components/default'
import { FormInputText, FormInputPhone } from '../../components/forms/formInputs'
import { FormValidationCompleteRegisterStepTwo } from '../../components/forms/formValidations'
import { acSetCompleteRegisterData } from '../../store/actions'
import { removeSpecialCharacters } from '../../utils'

/**
 * @description Renders step two of the complete resgister stepper. Each step is a separate form
 *
 * @author Maria Eduarda Franke
 * @param {Object} completeRegisterData - Stepper saved data
 * @param {function} handleBack - Function to handle back button click
 * @param {function} handleNext - Function to handle next button click
 * @param {boolean} isMobile - Whether the user accessed via mobile device or not
 * @returns {JSX.Element} The rendered CompleteRegisterStepTwoForm component.
 */
export const CompleteRegisterStepTwoForm = ({ completeRegisterData, handleBack, handleFinish, isMobile }) => {

    const defaultValues = {
        firstName: completeRegisterData?.firstName || '',
        lastName: completeRegisterData?.lastName || '',
        phone: completeRegisterData?.phone || ''
    }

    const dispatch = useDispatch()

    const isLoadingCompleteRegister = useSelector(state => state.customer.isLoadingCompleteRegister)
    const hasErrorCompleteRegister = useSelector(state => state.customer.hasErrorCompleteRegister)

    const { control, handleSubmit, formState: { errors } } = useForm({
        defaultValues: defaultValues,
        resolver: yupResolver(FormValidationCompleteRegisterStepTwo)
    })

    const onSubmit = handleSubmit((data) => {
        const phone = removeSpecialCharacters(data.phone)

        dispatch(acSetCompleteRegisterData({
            ...data,
            phone
        }))

        handleFinish({
            firstName: data.firstName,
            lastName: data.lastName,
            phone
        })
    })

    return (
        <Box component='form' onSubmit={onSubmit} noValidate>

            <FormInputText
                name='firstName'
                label='Nome'
                control={control}
                errors={errors.firstName}
                fullWidth
                margin='normal'
                required
            />
            <FormInputText
                name='lastName'
                label='Sobrenome'
                control={control}
                errors={errors.lastName}
                fullWidth
                margin='normal'
                required
            />
            <FormInputPhone
                name='phone'
                label='Celular'
                control={control}
                errors={errors.phone}
                fullWidth
                margin='normal'
                required
            />

            {
                hasErrorCompleteRegister && (
                    <Alert severity='error' message='Erro ao completar cadastro!' sx={{ mt: 2 }} />
                )
            }

            <Grid container sx={{ mt: 2 }}
                display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'
            >
                <Grid item xs={4} display='flex' justifyContent='flex-start'>
                    <Button onClick={handleBack}>
                        Voltar
                    </Button>
                </Grid>

                <Grid item xs={4} display='flex' justifyContent='center'>
                    {
                        isMobile && (
                            <MobileStepper
                                variant='dots'
                                position='static'
                                steps={3}
                                activeStep={1}
                            />
                        )
                    }
                </Grid>

                <Grid item xs={4} display='flex' justifyContent='flex-end'>
                    <Button type='submit' variant='contained' disabled={isLoadingCompleteRegister}>
                        Salvar
                    </Button>
                </Grid>

            </Grid>

        </Box>
    )

}

CompleteRegisterStepTwoForm.propTypes = {
    completeRegisterData: PropTypes.object,
    handleBack: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    isMobile: PropTypes.bool.isRequired
}
